import React, {Component} from 'react';
import {Button, Card, CardBody, TabPane, TabContent, Col, CardHeader, Nav, NavItem, NavLink, Row} from "reactstrap";
import axios from "axios";
import {serverPath} from "./common";
import classnames from 'classnames';
import {Link} from "react-router-dom";

import '../css/sponsors.css';

class SponsorsComponent extends Component{
    constructor(props){
        super(props);
        this.state={
            sponsors : [
                {
                    src: 'http://drwebgrade.matf.bg.ac.rs/src/assets/logo.png',
                    altText: 'WebGrade logo',
                    description: 'WebGrade je platforma namenjena studentima za lakše savladavanje gradiva iz programerskih predmeta. Omogućava studentima da rešavaju zadatke, šalju svoje rešenje na obradu i dobiju informacije o tačnosti svog rešenja. ',
                    contact: 'Aleksandra Kocić',
                    contactDescription: 'Autor sistema',
                    email: 'aleksandra_kocic@matf.bg.ac.rs',
                    website: 'http://drwebgrade.matf.bg.ac.rs/',
                    key: 1,
                    title: 'WebGrade',
                    tabs: 1
                },
                {
                    src: 'http://localhost/src/assets/logo-placeholder.png',
                    altText: 'Sponzor 3',
                    description: 'Kratak opis',
                    contact: 'Kontakt podaci',
                    contactDescription: '',
                    email: 'email',
                    website: '#',
                    key: 2,
                    title: 'Naziv sponzora',
                    tabs: 1
                },
                {
                    src: 'http://localhost/src/assets/logo-placeholder.png',
                    altText: 'Sponzor 3',
                    description: 'Kratak opis',
                    contact: 'Kontakt podaci',
                    contactDescription: '',
                    email: 'email',
                    website: '#',
                    key: 3,
                    title: 'Naziv sponzora',
                    tabs: 1
                },
                {
                    src: 'http://localhost/src/assets/logo-placeholder.png',
                    altText: 'Sponzor 3',
                    description: 'Kratak opis',
                    contact: 'Kontakt podaci',
                    contactDescription: '',
                    email: 'email',
                    website: '#',
                    key: 4,
                    title: 'Naziv sponzora',
                    tabs: 1
                },
                {
                    src: 'http://localhost/src/assets/logo-placeholder.png',
                    altText: 'Sponzor 3',
                    description: 'Kratak opis',
                    contact: 'Kontakt podaci',
                    contactDescription: '',
                    email: 'email',
                    website: '#',
                    key: 5,
                    title: 'Naziv sponzora',
                    tabs: 1
                },
                {
                    src: 'http://localhost/src/assets/logo-placeholder.png',
                    altText: 'Sponzor 3',
                    description: 'Kratak opis',
                    contact: 'Kontakt podaci',
                    contactDescription: '',
                    email: 'email',
                    website: '#',
                    key: 6,
                    title: 'Naziv sponzora',
                    tabs: 1
                }
            ]
        };
    }

    toggleTabs = (e, index, sponsorKey) => {
        e.preventDefault();

        let updatedSponsors = this.state.sponsors;
        updatedSponsors[sponsorKey-1].tabs = index;

        this.setState({
            sponsors: updatedSponsors
        });
    };

    render(props){
        return (
            <div className='col-md-8 offset-2'>
                <br/>
                <br/>
                <Row>
                    <Col className='col-md-6 offset-3'>
                        <h5> <i>
                            Veliku zahvalnost dugujemo sponzorima koji su prepoznali kvalitet platforme i omogućili njen dalji razvoj.
                            <br/>
                            Trudićemo se da opravdamo njihovo poverenje.
                            <br/>
                            <br/>
                            <span style={{'float': 'right'}}> WebGrade tim</span>
                            </i>
                        </h5>
                    </Col>
                </Row>
                <Row>
                    <Sponsor sponsor={this.state.sponsors[0]} toggleTabs={this.toggleTabs}/>
                    <Sponsor sponsor={this.state.sponsors[1]} toggleTabs={this.toggleTabs}/>
                    <Sponsor sponsor={this.state.sponsors[2]} toggleTabs={this.toggleTabs}/>
                    <Sponsor sponsor={this.state.sponsors[3]} toggleTabs={this.toggleTabs}/>
                    <Sponsor sponsor={this.state.sponsors[4]} toggleTabs={this.toggleTabs}/>
                    <Sponsor sponsor={this.state.sponsors[5]} toggleTabs={this.toggleTabs}/>
                </Row>
                <br/>
            </div>
    );
    }
}

function Sponsor(props) {
    return (
        <Col md="4">
        <Card className="card-coin card-plain">
            <CardHeader>
                <img alt="..." className="img-center img-fluid rounded-circle" src={props.sponsor.src}/>
                <h4 className="title">{props.sponsor.title}</h4>
            </CardHeader>
            <CardBody>
                <Nav className="nav-tabs-primary justify-content-center" tabs>
                    <NavItem>
                        <NavLink className={classnames({active: props.tabs === 1})}
                                 onClick={e => props.toggleTabs(e, 1, props.sponsor.key)}
                                 href="#">
                            O kompaniji
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({active: props.tabs === 2})}
                                 onClick={e => props.toggleTabs(e, 2, props.sponsor.key)}
                                 href="#">
                            Kontakt
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent
                    className="tab-subcategories"
                    activeTab={"tab" + props.sponsor.tabs}>
                    <TabPane tabId="tab1">
                        {props.sponsor.description}
                        <br/>
                        <br/>
                        <Button outline color="info" style={{'float': 'right'}}> <a href={props.sponsor.website} target={"_blank"} className='a-link'>Zvanična stranica <i className="fa fa-share-square"></i> </a></Button>
                    </TabPane>
                    <TabPane tabId="tab2">
                        <Row>
                            <Col md="3"> <i className="fa fa-address-card fa-4x" /> </Col>
                            <Col md="9">
                                <h4> {props.sponsor.contact} </h4>
                                <h6> <i> {props.sponsor.contactDescription} </i> </h6>
                                {props.sponsor.email}
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </CardBody>
        </Card>
    </Col>);
}

export default SponsorsComponent;